export function toTitleCase (str) {
  return str.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase() })
}

export function toHypenatedLowerCase (str) {
  return str.replace(/ /g, '-').toLowerCase()
}



// WEBPACK FOOTER //
// ./src/helpers/stringHelpers.js